import { useContext, useState } from "react";

import { LangContext } from "../../../context/LangContext";

import "./style.css"

function Selectors({ formData, setFormData }) {
    const [selected, setSelected] = useState(null);

    const { language } = useContext(LangContext);

    const setValue = (e, field) => {
        let newValue = e.target.value;

        if (field === 'quantity') {
            // Autorise uniquement les chiffres, + et -, et enlève les autres caractères
            newValue = newValue.replace(/[^0-9+-]/g, '');

            // Empêche plusieurs signes ou mauvais placement
            const signMatch = newValue.match(/^([+-]?)(\d*)$/);
            if (!signMatch) return;

            const sign = signMatch[1];
            const digits = signMatch[2];

            // Reconstruit la valeur proprement
            newValue = sign + digits;
        }

        setFormData({
            ...formData,
            [field]: newValue
        });
    };

    const setCategory = (e, idx, field) => {
        let newValue = e.target.value;
        const newSelectors = formData.selectors.map(s => ({ ...s }));

        if (field === 'quantity') {

            newValue = newValue.replace(/[^0-9+-]/g, '');           // 1. garde chiffres et signes
            newValue = newValue.replace(/^([+-]?)[+-]*/, '$1');     // 2. un seul signe au début
            newValue = newValue.replace(/^0+(?=\d)/, '');           // 3. enlève les zéros initiaux sauf si "0" seul

            if (!/^[+-]?\d*$/.test(newValue)) return;               // 4. autorise "", "+", "-", "0", "123", "+123"…

            newSelectors[idx][field] = newValue;

        }
        else {
            newSelectors[idx][`name_${language}`] = newValue;
        }

        setFormData({
            ...formData,
            selectors: newSelectors
        });
    }

    const switchTypeOfQty = () => {
        if (!formData.multi_qty) {
            setFormData({
                ...formData,
                selectors: formData.selectors.map((cat) => ({
                    ...cat,
                    quantity: formData.quantity || '',
                    weight: formData.weight || ''
                })),
                multi_qty: true,
                quantity: undefined,
            });
        } else {
            setFormData({
                ...formData,
                selectors: formData.selectors.map(({ quantity, weight, ...rest }) => rest),
                multi_qty: false,
                quantity: '',
            });
        }
    };

    const addSelector = () => {
        const newSelectors = [...formData.selectors];

        let newCategory = {
            name_fr: '',
            name_en: ''
        };

        // Si qte individuel ajouter "quantity"
        if (formData.multi_qty) newCategory.quantity = '';

        newSelectors.push(newCategory);

        setFormData({
            ...formData,
            selectors: newSelectors
        })
    }

    return (
        <>
            {formData.multi_qty !== undefined &&
                <div className="selector_field">
                    <span>
                        <input
                            type="text"
                            placeholder={`Titre du selecteur (${language})`}

                            value={formData[`category_${language}`]}
                            onChange={(e) => setValue(e, `category_${language}`)}
                        /> :
                    </span>

                    {!formData._id && formData.multi_qty !== undefined &&
                        <button
                            className="btn_multi_qty"
                            onClick={() => switchTypeOfQty()}
                        >
                            <i>{formData.multi_qty && 'x'}</i>
                            qte individuelle
                        </button>
                    }

                    <select onChange={(e) => setSelected(e.target.value)}>
                        <option value="null">Selecteur d'article en {language === 'fr' ? 'français' : 'anglais'}</option>
                        <option value="edit">+ Modifier les articles</option>

                        {formData.selectors.length !== 0 && formData.selectors.map((category, idx) => category[`name_${language}`] !== '' &&
                            <option key={idx} value={idx}>{category[`name_${language}`]}</option>
                        )}
                    </select>
                </div>
            }

            {selected === 'edit' &&
                <ul className="select_list">
                    {formData.selectors.length !== 0 && formData.selectors.map((category, idx) =>
                        <li key={idx}>
                            <input
                                type="text"
                                className="inp_text"

                                value={category[`name_${language}`]}
                                onChange={(e) => setCategory(e, idx, `name_${language}`)}

                                placeholder={`${formData[`category_${language}`]} (${language})`}
                            />

                            {formData.multi_qty &&
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    className="inp_qty"

                                    placeholder="qte"
                                    value={category.quantity || ''}
                                    onChange={(e) => setCategory(e, idx, 'quantity')}
                                />
                            }
                        </li>
                    )}

                    <li>
                        <button
                            className="add_category"
                            onClick={() => addSelector()}
                        >ajouter une catégorie</button>
                    </li>
                </ul>
            }
        </>
    )
}

export default Selectors;